import {Dialog, Transition} from "@headlessui/react";
import React, {Fragment, useEffect, useState} from "react";
import {RiCloseLine} from "react-icons/ri";


const FileReaderModal = ({setFileReaderModalOpen, modalTitle}) => {
  const [open, setOpen] = useState(true);
  const [contents, setContents] = useState('');

  const closeModal = () => {
    setOpen(false);
    setFileReaderModalOpen(false);
  }

  useEffect(() => {
    getTextData();
  }, [modalTitle]);

  const getTextData = async () => {
    let targetUrl = process.env.REACT_APP_SERVER_FOOTER_CLAUSE_FOLDER;
    targetUrl = targetUrl + encodeURI(modalTitle) + ".txt?mt=" + (new Date().getTime()/1000*60*10);

    try {
      const response = await fetch(targetUrl);
      const data = await response.text();
      setContents(data);
      console.log('이용약관->', data);
    } catch (err) {
      console.error("데이터를 읽어오는데 실패하였습니다.", err);
    }
  };

  return (
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                    className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                  <div className="w-auto">
                    {/* <-- 모달 타이틀 + 닫기 버튼 --> */}
                    <div className="flex flex-row justify-between items-center mb-3">
                      <h3 className="text-xl font-semibold leading-6 text-gray-900">{modalTitle}</h3>
                      <button onClick={closeModal} className="bg-gray-200 rounded-md">
                        <RiCloseLine className="w-5 h-5"/>
                      </button>
                    </div>

                    {/* <-- 모달 내용 --> */}
                    <div className="py-5 h-[25rem] overflow-y-auto text-sm">
                      <p>{contents.split('\n').map((line, index) => {
                            return (
                                <span key={index}> {index > 0 && <br/>} {line} </span>
                            )
                          }
                      )}</p>
                    </div>

                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
  )
}
export default FileReaderModal;